<template>
  <div class="row" v-if="!isParent">
    <div class="col-6 col-sm-4 col-md-3" v-for="(item, index) in data" :key="index">
      <p class="mb-0 text-muted"><small>{{index}}</small></p>
      <p class="font-weight-bold mb-1">{{item ? item : '-'}}</p>
    </div>
  </div>
  <div class="row" v-else>
    <div class="col-6 col-md-4" v-for="(item, index) in data" :key="index">
      <p class="font-weight-bold mb-1">{{index}}</p>
      <div class="row" v-for="(itemData, index) in parentBasicInfo(item)" :key="index">
        <div class="col-4 text-muted"><small>{{index}}:</small></div>
        <div class="col-8 font-weight-bold">{{itemData ? itemData : '-'}}</div>
      </div>
      <template v-if="showContact">
        <p class="mt-2 mb-1">Contact Info</p>
        <a-divider />
        <div class="row" v-for="(itemData, index) in parentContactInfo(item.contact)" :key="index">
          <div class="col-4 text-muted"><small>{{index}}:</small></div>
          <div class="col-8 font-weight-bold">{{itemData ? itemData : '-'}}</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { parentBasicInfo, parentContactInfo } from '../fields'
export default {
  props: {
    data: [Object, Array],
    isParent: {
      type: Boolean,
      default: false,
    },
    showContact: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {
      parentDetails: null,
    }
  },
  methods: {
    parentBasicInfo,
    parentContactInfo,
  },
}
</script>
